import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Wine } from "lucide-react";

const StandUpNaBankiet = () => (
  <SeoPageLayout title="Stand-up na" titleAccent="bankiet firmowy">
    <SeoSection title="Występ komediowy na bankiecie firmowym">
      <p>Bankiet firmowy to wyjątkowa okazja, aby uhonorować pracowników, świętować sukcesy i zacieśnić relacje w zespole. Profesjonalny stand-up na bankiecie dodaje wydarzeniu blasku i tworzy atmosferę, w której formalność łączy się z autentycznym śmiechem. Nasi komicy potrafią dostosować poziom humoru do elegancji bankietu, zachowując przy tym lekkość i naturalność.</p>
    </SeoSection>

    <SeoSection title="Kiedy zamówić komika na bankiet?">
      <SeoStyledList items={[
        "Rocznice i jubileusze firmy",
        "Bankiety podsumowujące rok",
        "Uroczyste kolacje z klientami i partnerami",
        "Gale z wręczeniem nagród",
        "Bankiety po konferencjach i targach",
        "Eleganckie wieczory integracyjne"
      ]} />
    </SeoSection>

    <SeoSection title="Format występu na bankiecie">
      <p>Występ komediowy na bankiecie zazwyczaj trwa 20-40 minut i odbywa się po głównym daniu, przed deserem lub w przerwie między częścią oficjalną a zabawą. Komik może też pełnić rolę prowadzącego wieczór, płynnie łącząc elementy programu z humorem. Materiał jest zawsze dopasowany do okazji - elegancki, ale niepozbawiony charakteru.</p>
      <SeoHighlightBox icon={Wine}>
        Idealny moment na występ: po głównym daniu, przed deserem - kiedy goście są w doskonałym nastroju i otwarci na rozrywkę.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Zamów stand-up na bankiet">
      <p>Zaplanuj bankiet, który goście zapamiętają nie tylko z powodu wyśmienitej kuchni, ale też z najlepszych żartów wieczoru. Skontaktuj się z nami - zaproponujemy komika i format idealnie dopasowany do stylu Twojego bankietu.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpNaBankiet;
